import { createClient } from '@/lib/supabase/client';

export type AuditAction =
  | 'student_verified'
  | 'student_revoked' |'certificate_issued' |'lecturer_approved' |'lecturer_rejected' |'lecturer_access_granted' |'lecturer_access_revoked' |'withdrawal_approved' |'withdrawal_rejected' |'withdrawal_paid' |'admin_login';

export interface AuditLogEntry {
  action: AuditAction;
  targetId?: string;
  targetName?: string;
  details?: Record<string, unknown>;
}

/**
 * Write an audit log entry to the admin_audit_logs table.
 * Silently fails — never blocks the main action.
 */
export async function logAdminAction(entry: AuditLogEntry): Promise<void> {
  try {
    const supabase = createClient();
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from('admin_audit_logs').insert({
      admin_id: user?.id ?? null,
      admin_email: user?.email ?? 'unknown',
      action: entry.action,
      target_id: entry.targetId ?? null,
      target_name: entry.targetName ?? null,
      details: entry.details ?? null,
      performed_at: new Date().toISOString(),
    });
  } catch {
    // Audit logging must never break the main flow
  }
}
